/* TerraLife — option « étiquette de bac » (snippets/terralife-label-addon.liquid).
   La case ouvre le choix du fond et l'aperçu. Quand l'espèce de la page est ajoutée au panier
   (événement cartUpdate du formulaire produit du thème), on ajoute la variante choisie du produit
   étiquette, avec l'espèce en propriété de ligne, puis on redessine le mini-panier. */
(() => {
  const box = document.querySelector('[data-tl-label]');
  if (!box || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const check = box.querySelector('[data-tl-label-check]');
  const panel = box.querySelector('[data-tl-label-panel]');
  const img = box.querySelector('[data-tl-label-img]');
  const thumb = box.querySelector('.tl-label__thumb');
  const variants = new Set((box.dataset.productVariants || '').split(','));

  check.addEventListener('change', () => {
    panel.hidden = !check.checked;
  });

  box.querySelectorAll('.tl-label__model input').forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!radio.checked || !img) return;
      if (radio.dataset.img) {
        img.src = radio.dataset.img;
        if (thumb) thumb.src = radio.dataset.img;
      }
      img.alt = `Aperçu de l'étiquette, fond ${radio.dataset.title.toLowerCase()}`;
    });
  });

  let busy = false;
  subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    if (busy || !check.checked) return;
    if (!event || event.source !== 'product-form' || !variants.has(String(event.productVariantId))) return;
    const model = box.querySelector('.tl-label__model input:checked');
    if (!model) return;
    busy = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(model.value), quantity: 1, properties: { Pour: box.dataset.species } }],
          sections: 'minicart-form',
          sections_url: location.pathname,
        }),
      });
      if (!res.ok) throw new Error(String(res.status));
      const state = await res.json();
      // L'étiquette est ajoutée : on décoche pour ne pas en rajouter une à chaque clic.
      check.checked = false;
      panel.hidden = true;
      await refresh(state);
    } catch (e) {
      if (typeof showToast === 'function') {
        showToast("L'étiquette n'a pas pu être ajoutée au panier. Réessaie depuis la fiche.", 5000, 'modal-error');
      }
    } finally {
      busy = false;
    }
  });

  async function refresh(state) {
    if (document.getElementById('main-cart-items')) {
      location.reload();
      return;
    }
    const html = state.sections && state.sections['minicart-form'];
    const target = document.getElementById('minicart-form');
    if (html && target) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
      if (fresh) target.innerHTML = fresh.innerHTML;
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && typeof drawer.cartAction === 'function') drawer.cartAction();
    }
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    document.querySelectorAll('.cart-count').forEach((el) => {
      el.innerHTML = el.classList.contains('cart-count-drawer')
        ? `(${cart.item_count})`
        : cart.item_count > 100
          ? '~'
          : cart.item_count;
    });
    const total = document.querySelector('header-total-price');
    if (total && typeof total.updateTotal === 'function') total.updateTotal(cart);
    document.querySelectorAll('free-ship-progress-bar').forEach((bar) => bar.init(cart.items_subtotal_price));
  }
})();
